module.exports = __webpack_public_path__ + "img/mosquita_promo_code.7b6101b9.png";